import { Chip } from "@heroui/react";

import {
  EMPTY_BLOCKED_COUNTS,
  useGetBlockedCounts,
} from "@/features/clinic/api/appointments";
import {
  ATTENTION_QUEUE,
  queueCount,
} from "@/features/clinic/helpers/appointment-filter-url";

/**
 * How much the appointments board owes, readable from anywhere in the app.
 *
 * The count only reaches a person who is already on the board otherwise, which
 * is the half of the audience that does not need telling. Nothing renders at
 * zero - an empty badge would train people to ignore a full one.
 */
export const AppointmentsAttentionBadge = () => {
  const { data: counts = EMPTY_BLOCKED_COUNTS } = useGetBlockedCounts();

  const total = queueCount(counts, ATTENTION_QUEUE);

  if (total === 0) return null;

  return (
    <Chip color="warning" size="sm" variant="soft">
      {total}
    </Chip>
  );
};
